module.exports = __webpack_public_path__ + "static/media/(V)_MG_5653_-_Cia_Termal_Beachewear_-_Moda_Masculina.3ab36795.jpg";